import _ from 'lodash';
import React, { ReactNode, useContext } from 'react';
import FormContext from 'src/presentation/contexts/FormContext';
import styled from 'styled-components';

import { Body, Section } from './Layout';
import Switch from './Switch';

interface DetailedSwitchProps {
  attr: string;
  conditionalText: boolean;
  'data-aid': string;
  disabledText?: ReactNode;
  enabledText?: ReactNode;
  label?: string;
  onChange?: Function;
  subtext?: string;
  switchHeading: ReactNode;
}

export const DetailedSwitch: React.FC<DetailedSwitchProps> = ({
  attr,
  conditionalText,
  'data-aid': dataAid,
  disabledText,
  enabledText,
  label,
  onChange,
  subtext,
  switchHeading,
}) => {
  const { workingState } = useContext(FormContext);

  let controlText: string | ReactNode = subtext;
  if (conditionalText) {
    const attrValue = !!_.get(workingState, attr);
    controlText = attrValue ? enabledText : disabledText;
  }

  return (
    <FormBody>
      <Section>
        <EnableConfigFormRow>
          <div>
            <Switch data-aid={dataAid} attr={attr} label={label || ''} onChange={onChange} />
          </div>
          <div>
            <Heading data-aid={`${dataAid}-heading`}>{switchHeading}</Heading>
            <Subtext>{controlText}</Subtext>
          </div>
        </EnableConfigFormRow>
      </Section>
    </FormBody>
  );
};

const FormBody = styled(Body)`
  max-width: 100%;
  padding: 0;
  font-size: 13px;
`;

const Heading = styled.h4`
  margin: 0;
  line-height: 24px;
`;

const Subtext = styled.span`
  color: ${p => p.theme.colors.gray700};
`;

const EnableConfigFormRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  margin-bottom: 4px;
`;
